// extracted by mini-css-extract-plugin
export default {"errorImg":"errorImg__j6Q9TGB0"};